// useForm.js

import { useMutation, useQueryClient } from "@tanstack/react-query";

import useToastPromise from "./useToast";
import { normalizeInvalidateKeys } from "./hookUtils";

const useMutate = (
  apiFunc,
  invalidateQue = [],
  onSettled=() => {},
  onClose,
  onErrorCallback
) => {
  const { showToastPromise } = useToastPromise();
  const queryClient = useQueryClient();
  const invalidateQueryKeys = normalizeInvalidateKeys(invalidateQue);

  const { mutate, isPending } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(apiFunc, data);
    },
    onSuccess: (res) => {
      invalidateQueryKeys.forEach((queryKey) => {
        queryClient.invalidateQueries({
          queryKey,
        });
      });
      onClose?.(res.data);
    },
    onError: (error) => {
      console.error("Error", error);
      onErrorCallback?.();
    },
    onSettled: () => {
      onSettled?.();
    },
  });

  return { mutate, isPending };
};

export default useMutate;
